export var AccountSection;
(function (AccountSection) {
    AccountSection["Assets"] = "assets";
    AccountSection["Payables"] = "payables";
    AccountSection["PartnersCapital"] = "partnersCapital";
    AccountSection["Income"] = "income";
    AccountSection["Expenses"] = "expenses";
})(AccountSection || (AccountSection = {}));
export var BalanceSheetSection;
(function (BalanceSheetSection) {
    // Assets
    BalanceSheetSection["InvestmentsAtCost"] = "investmentsAtCost";
    BalanceSheetSection["UnrealisedGainLoss"] = "unrealisedGainLoss";
    BalanceSheetSection["ReceivablesAndPrepayments"] = "receivablesAndPrepayments";
    BalanceSheetSection["AccruedIncome"] = "accruedIncome";
    BalanceSheetSection["CapitalDueFromPartners"] = "capitalDueFromPartners";
    // Liabilities (Payables section in GL)
    BalanceSheetSection["AccountsPayable"] = "accountsPayable";
    BalanceSheetSection["AccruedExpenses"] = "accruedExpenses";
    BalanceSheetSection["CapitalDueToPartners"] = "capitalDueToPartners";
})(BalanceSheetSection || (BalanceSheetSection = {}));
//# sourceMappingURL=schema.js.map